/*@ngInject*/
const CollaborationRepository = function (baseRepository, currentSubmissionModel) {

    angular.extend(this, baseRepository);

    this.loadCollaborationItems = function (submissionId, searchInput) {
        var url = '/rest/Submission/' + submissionId + '/CollaborationItem';

        if (searchInput) {
            url += '?search=' + encodeURIComponent(searchInput);
        } else {
            url += '?registrationIdentifier=/SubmissionCollaborationItem/' + submissionId;
        }

        if (!searchInput) {
            currentSubmissionModel.addRegistration(url);
        }

        return this.get(url);
    };

    this.refreshCollaborationAttachments = function (submissionId) {
        const url = '/rest/Submission/' + submissionId + '/CollaborationItem/external';
        return this.get(url);
    };
};

angular.module('gw-um-submission')
    .service('collaborationRepository', CollaborationRepository);
